import { render, staticRenderFns } from "./info.vue?vue&type=template&id=6a71312b&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=6a71312b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71312b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a71312b')) {
      api.createRecord('6a71312b', component.options)
    } else {
      api.reload('6a71312b', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=6a71312b&scoped=true", function () {
      api.rerender('6a71312b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/videoChannel/info.vue"
export default component.exports